import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import CrashlyticService from "services/crashlytics";

CrashlyticService.init();

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(<App />);
